<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="优惠券名称" prop="couponName">
                        <Input v-model="info.couponName" :maxlength="100" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="优惠券面值" prop="amount">
                        <input-number v-model="info.amount" placeholder>
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="有效期" prop="startDate">
                        <DatePicker
                            v-model="validity"
                            transfer
                            style="width: 100%;"
                            type="datetimerange"
                            :options="optionsDate"
                        ></DatePicker>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="发放对象" prop="releasePeople">
                        <Select v-model="info.releasePeople" transfer clearable placeholder>
                            <Option
                                v-for="(item, index) in releasePeopleList"
                                :value="item.id"
                                :key="index"
                            >{{ item.text }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="发放时机" prop="releaseTiming">
                        <Select v-model="info.releaseTiming" transfer clearable placeholder>
                            <Option
                                v-for="(item, index) in releaseTimingList"
                                :value="item.id"
                                :key="index"
                            >{{ item.text }}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="数量" prop="num">
                        <input-number v-model="info.num" placeholder :allowDecimal="false"></input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="适用范围" prop="useRange">
                        <Select v-model="info.useRange" transfer clearable placeholder>
                            <Option
                                v-for="(item, index) in useRangeList"
                                :value="item.id"
                                :key="index"
                            >{{ item.text }}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="适用分类" prop="catalogIds" v-if="info.useRange == 1">
                        <Select v-model="info.catalogIds" transfer clearable placeholder multiple>
                            <Option
                                v-for="(item, index) in catalogList"
                                :value="item.id"
                                :key="index"
                            >{{ item.title }}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="使用条件" prop="useRule">
                        <Select v-model="info.useRule" transfer clearable placeholder disabled>
                            <Option
                                v-for="(item, index) in useRuleList"
                                :value="item.id"
                                :key="index"
                            >{{ item.text }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="满金额" prop="fullAmount">
                        <input-number v-model="info.fullAmount" placeholder>
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="使用说明" prop="description">
                        <Input v-model="info.description" :maxlength="100" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            :maxlength="1000"
                            type="textarea"
                            placeholder="0-1000个字"
                            :rows="3"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { cInfoView, cInfoAdd, cInfoUpdate } from "@/api/market";
import { catalogList } from "@/api/merch";
import Dict from "_u/dict";
import { ymdL, toDate } from "_u/helper";
import dayjs from "dayjs";

export default {
    name: "n-info-form",

    props: {
        id: {
            type: [String, Number],
            default: "",
        },
    },

    components: {},

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: this.id,
                couponName: "", // 优惠券名称
                amount: "", // 优惠券面值
                startDate: "", // 有效开始日期
                endDate: "", // 有效截止日期
                releasePeople: "", // 分发对象
                releaseTiming: "", // 发放时机
                num: "", // 数量
                useRange: "", // 适用范围
                catalogIds: "", // 适用分类
                useRule: "full_reduction", // 使用条件
                fullAmount: "", // 满金额
                description: "", // 使用说明
                remark: "", // 备注
                enabled: 0, // 发布状态
                ver: "", // 是否分发
            },

            dict: {
                releasePeople: Dict.NULL,
                releaseTiming: Dict.NULL,
                useRange: Dict.NULL,
                useRule: Dict.NULL,
            },

            optionsDate: {
                disabledDate(date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                },
            },
            catalogList: [], // 分类列表
            releasePeopleList: [],
            releaseTimingList: [],
            useRuleList: [], // 使用条件
            useRangeList: [], // 使用范围
        };
    },

    computed: {
        ruleValidate() {
            var valid ={
                couponName: [{ required: true, message: "优惠券名称必填" }],
                amount: [{ required: true, message: "优惠券面值必填" }],
                startDate: [{ required: true, message: "有效期必填" }],
                releasePeople: [{ required: true, message: "分发对象必填" }],
                releaseTiming: [{ required: true, message: "发放时机必填" }],
                num: [{ required: true, message: "数量必填" }],
                useRange: [{ required: true, message: "适用范围必填" }],
                fullAmount: [{ required: true, message: "满金额必填" }],
            }
            if(this.info.useRange=='1'){//单笔
                valid.catalogIds=[{ required: true, message: "适用分类必填" }]
            }
            return valid
        },
        validity: {
            get() {
                return this.info.startDate
                    ? [
                          dayjs(this.info.startDate).format(
                              "YYYY-MM-DD HH:mm:ss"
                          ),
                          dayjs(this.info.endDate).format(
                              "YYYY-MM-DD HH:mm:ss"
                          ),
                      ]
                    : ["", ""];
            },
            set(val) {
                this.info.startDate = val[0] ? ymdL(val[0]) : "";
                this.info.endDate = val[1] ? ymdL(val[1]) : "";
            },
        },
    },

    methods: {
        fetch() {
            if (this.id) {
                return cInfoView(this.id);
            } else {
                return Promise.resolve();
            }
        },
    },

    mounted() {
        var $info = this.$refs.info;

        // 按钮配置
        var btns = [{ type: "default", text: "取消", name: "cancel" }];

        if (this.$can("update")) {
            btns.unshift({
                type: "primary",
                name: "confirm",
                text: "确定",
            });
        }
        this.$modal.updateBtns(btns);

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                Dict.get([
                    "release_people",
                    "release_timing",
                    "use_range",
                    "use_rule",
                ]),
                this.fetch(),
                catalogList({ pageNo: 1, pageSize: 999 }),
            ])
                .then((args) => {
                    var [dictGroup, view, catalog] = args;
                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });
                    this.useRuleList = this.dict.useRule.toList();
                    this.releaseTimingList = this.dict.releaseTiming.toList();
                    this.releasePeopleList = this.dict.releasePeople.toList();
                    this.useRangeList = this.dict.useRange.toList();

                    if (view) {
                        var viewData = view.data;
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity;
                        const couponRules = JSON.parse(viewData.couponRules)
                        viewData.amount = couponRules.amount/100;
                        viewData.fullAmount = couponRules.fullAmount/100;
                        viewData.useRule = couponRules.useRule;
                        if(viewData.catalogIds){
                            viewData.catalogIds= viewData.catalogIds.split(",");
                        }
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        );
                    }
                    this.catalogList = catalog ? catalog.data.page.list : [];
                })
                .finally(() => {
                    next();
                });
        });

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info
                .validate()
                .then(() => {
                    var couponRules = JSON.stringify({
                        amount: this.info.amount * 100,
                        useRule: this.info.useRule ,
                        fullAmount: this.info.fullAmount* 100,
                    });
                    var formData = Object.assign({ couponRules }, this.info);
                    formData.amount *= 100;
                    formData.fullAmount *= 100;
                    if(formData.catalogIds){
                        formData.catalogIds = formData.catalogIds.join(",");
                    }
                    if (this.id) {
                        return cInfoUpdate(formData);
                    } else {
                        return cInfoAdd(formData);
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t("tips.update.success"));
                    } else {
                        this.$Message.success(this.$t("tips.add.success"));
                    }
                })
                .catch((err) => {
                    options.closeModal = false;
                })
                .finally(() => {
                    next();
                });
        });
    },
};
</script>
<style lang="less" scoped></style>
